/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Ai_IntroInputs */

const en_read_along_ai_intro = /** @type {(inputs: Read_Along_Ai_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get an overview, summary, and key points from your full document. Long documents are read in sections and combined. Generation starts only when you choose it.`)
};

const es_read_along_ai_intro = /** @type {(inputs: Read_Along_Ai_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtén una visión general, un resumen y los puntos clave del documento completo. Los documentos largos se leen por secciones y se combinan. La generación comienza solo cuando tú la inicias.`)
};

/**
* | output |
* | --- |
* | "Get an overview, summary, and key points from your full document. Long documents are read in sections and combined. Generation starts only when you choose it." |
*
* @param {Read_Along_Ai_IntroInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_intro = /** @type {((inputs?: Read_Along_Ai_IntroInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_IntroInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_intro(inputs)
	return en_read_along_ai_intro(inputs)
});